import React from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';

import { mediaMobile, mediaTablet } from '../utils/getResponsiveTag';

import Card from './Card';

class Carousel extends React.Component {
  render() {
    const { items, selectDomain, isNewRegistry, contactLink } = this.props;
    let slidesToShow = 4;
    let slidesToScroll = 4;

    if (mediaTablet()) {
      slidesToShow = 3;
      slidesToScroll = 3;
    }

    if (mediaMobile()) {
      slidesToShow = 1;
      slidesToScroll = 1;
    }

    const settings = {
      dots: !mediaMobile(),
      centerMode: mediaMobile(),
      arrows: !mediaMobile(),
      infinite: false,
      speed: 800,
      cssEase: 'cubic-bezier(.12,.82,.61,1)',
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToScroll,
    };

    if (items && items.length === 0) return false;

    if (isNewRegistry) {
      return (
        <Slider {...settings}>
          {items.map(({ domainName, statuses }, index) => {
            const delay = Math.max(0, index * 175);
            const title = domainName.substring(domainName.indexOf('.'));
            return (
              <CSSTransition
                in={!!domainName}
                key={index}
                appear
                timeout={!mediaMobile() ? 1000 + delay : 0}
                classNames="fade"
              >
                <Card
                  key={index}
                  selectDomain={selectDomain}
                  isNewRegistry={isNewRegistry}
                  contactLink={contactLink}
                  status
                  statuses={statuses}
                  title={title}
                  description={title}
                  styles={{
                    transitionDelay: `${!mediaMobile() ? delay : 0}ms`,
                  }}
                />
              </CSSTransition>
            );
          })}
        </Slider>
      );
    } else {
      return (
        <Slider {...settings}>
          {items.map(({ domain, status }, index) => {
            const delay = Math.max(0, index * 175);
            const title = domain.substring(domain.indexOf('.'));
            return (
              <CSSTransition
                in={!!domain}
                key={index}
                appear
                timeout={!mediaMobile() ? 1000 + delay : 0}
                classNames="fade"
              >
                <Card
                  key={index}
                  selectDomain={selectDomain}
                  isNewRegistry={isNewRegistry}
                  status={status}
                  title={title}
                  description={title}
                  styles={{
                    transitionDelay: `${!mediaMobile() ? delay : 0}ms`,
                  }}
                />
              </CSSTransition>
            );
          })}
        </Slider>
      );
    }
  }
}

Carousel.propTypes = {
  items: PropTypes.array,
  selectDomain: PropTypes.func,
  isNewRegistry: PropTypes.bool,
  contactLink: PropTypes.string,
};

export default Carousel;
